import { useEffect, useState } from "react";
import api from "../lib/api";
import { useAuth } from "../lib/auth";
import { Spinner, EmptyState } from "../components/states";
import { toast } from "sonner";
import { BackButton, Breadcrumbs, ExternalLink, useEscape } from "../lib/nav";

export default function Artists() {
  const { user } = useAuth();
  const [djs, setDjs] = useState([]);
  const [loading, setLoading] = useState(true);
  const load = () => Promise.all([api.get("/djs"), api.get("/artists")]).then(([d, a]) => {
    const merged = [...d.data.map((x) => ({ ...x, kind: "dj" })), ...a.data.map((x) => ({ ...x, kind: "artist" }))];
    setDjs(merged); setLoading(false);
  }).catch(() => setLoading(false));
  useEffect(() => { load(); }, []);

  const follow = async (id) => {
    if (!user) { toast.error("Sign in to follow"); return; }
    try { const { data } = await api.post(`/user/follow/${id}`); toast.success(data.following ? "Following" : "Unfollowed"); } catch { toast.error("Failed"); }
  };

  if (loading) return <Spinner />;
  return (
    <div className="mx-auto max-w-[1600px] px-4 sm:px-6 py-8">
      <div className="flex items-center gap-4 flex-wrap mb-4"><BackButton fallback="/" /><Breadcrumbs items={[{ label: "Live", to: "/" }, { label: "Artists" }]} /></div>
      <h1 className="font-display text-4xl sm:text-5xl font-extrabold uppercase tracking-tight">Artists</h1>
      <p className="mono-label text-[#71717A] mt-2">RESIDENTS & GUEST SELECTORS</p>
      {djs.length === 0 ? <EmptyState title="No artists yet" /> : (
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 mt-8">
          {djs.map((a, i) => (
            <div key={a.id} data-testid={`artist-${a.id}`} className="card-copper rounded-xl overflow-hidden fade-up text-center" style={{ animationDelay: `${i * 0.04}s` }}>
              <div className="aspect-square overflow-hidden bg-[#1A1A22]">
                <img src={a.profile_image || a.image} alt={a.stage_name || a.name} className="w-full h-full object-cover" />
              </div>
              <div className="p-4">
                <p className="font-display font-bold truncate">{a.stage_name || a.name}</p>
                <p className="mono-label text-[#71717A] mt-1 truncate">{(a.genres || []).join(" · ") || a.location}</p>
                {a.kind === "dj" && (
                  <button data-testid={`follow-${a.id}`} onClick={() => follow(a.id)} className="mono-label mt-3 w-full border border-[#E8552A]/40 text-[#E8552A] rounded-full py-1.5 hover:bg-[#E8552A]/10">FOLLOW</button>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
